/**
 * 登录以后执行的接口
 * 只执行一次 除非刷新页面
 */
import type { RouteLocationNormalizedGeneric } from 'vue-router'
import { useBanner } from '@/api/match/hooks/useBanner'
// import { useStatistical } from '@/api/match/hooks/useStatistical'
import { useUserStoreWithOut } from '@/store/modules/user'

const userStore = useUserStoreWithOut()

export async function initFetch(to?: RouteLocationNormalizedGeneric) {
  // const { path, query } = to
  // const { sportId } = query || {}

  try {
    userStore.fetchAccessCheck()

    userStore.setDefalutUpDown()

    // 获取App配置参数
    await userStore.setUserConfig()

    // 获取账户信息
    await userStore.getAccountInfo()
  } catch (err) {
    console.log('[err]', err)
  }

  // 赛事统计
  // useStatistical({ autoFetch: true, reset: !sportId && ['/index'].includes(path) })

  // 获取banner
  useBanner({ autoFetch: true })
}
